import React from 'react';
import { View, TouchableOpacity, Text, StyleSheet } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

interface ToggleButtonProps {
  isAutoMode: boolean;
  onToggle: (autoMode: boolean) => void;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  isAutoMode,
  onToggle,
}) => {
  const styles = StyleSheet.create({
    toggleContainer: {
      flexDirection: 'row',
      borderRadius: 25,
      padding: 4,
      marginBottom: 0,
      alignSelf: 'center',
      marginTop: -10,
    },
    toggleButton: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 8,
      paddingHorizontal: 16,
      borderRadius: 21,
      gap: 8,
    },
    toggleButtonActive: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    toggleText: {
      color: 'rgba(255, 255, 255, 0.4)',
      fontSize: 14,
    },
    toggleTextActive: {
      color: '#f0f0f0',
    },
  });

  return (
    <View style={styles.toggleContainer}>
      <TouchableOpacity
        onPress={() => onToggle(false)}
        style={[styles.toggleButton, !isAutoMode && styles.toggleButtonActive]}
      >
        <MaterialIcons 
          name="touch-app" 
          size={20} 
          color={!isAutoMode ? "#fff" : "rgba(255, 255, 255, 0.6)"} 
        />
        <Text style={[styles.toggleText, !isAutoMode && styles.toggleTextActive]}>
          Tap to Talk
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => onToggle(true)}
        style={[styles.toggleButton, isAutoMode && styles.toggleButtonActive]}
      >
        <MaterialIcons 
          name="mic" 
          size={20} 
          color={isAutoMode ? "#fff" : "rgba(255, 255, 255, 0.6)"} 
        />
        <Text style={[styles.toggleText, isAutoMode && styles.toggleTextActive]}>
          Auto Detect
        </Text>
      </TouchableOpacity>
    </View>
  );
};
